"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _indexCool = _interopRequireDefault(require("@/components/head/index-cool"));
var _user = require("@/api/user");
var _default = exports.default = {
  components: {
    headr: _indexCool.default
  },
  data: function data() {
    return {
      formDate: '',
      dialogForm: {
        multipartFiles: [],
        fullName: '',
        contactInformation: '',
        problemDescription: '',
        projectId: this.$store.state.project.projectInfo.id
      },
      files: [],
      dialogImageUrl: '',
      dialogVisible: false,
      dialogRules: {
        fullName: [{
          required: true,
          message: '请输入您的姓名',
          trigger: 'blur'
        }],
        problemDescription: [{
          required: true,
          message: '请输入您的具体描述',
          trigger: 'blur'
        }],
        contactInformation: [{
          required: true,
          message: '请输入您的联系方式',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    uploadFile: function uploadFile(file) {
      this.files.push(file.file);
    },
    handleRemove: function handleRemove(file, fileList) {
      //console.log(file, fileList)
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    subPicForm: function subPicForm() {
      var _this = this;
      this.$refs['dialogForm'].validate(function (valid) {
        if (valid) {
          _this.dialogForm.multipartFiles = [];
          _this.files = [];
          _this.$refs.upload.submit();
          _this.getProjectQuestionInfoData(_this.dialogForm);
        }
      });
    },
    handleExceed: function handleExceed(file, flies) {
      this.$message.error('最多只能上传10张');
    },
    getProjectQuestionInfoData: function () {
      var _getProjectQuestionInfoData = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dialogForm) {
        var _this2 = this;
        var i, file;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.files.length)) {
                _context.next = 8;
                break;
              }
              file = this.files[i];
              _context.next = 5;
              return this.uploadImage(file);
            case 5:
              i++;
              _context.next = 1;
              break;
            case 8:
              //console.log('getProjectQuestionInfoData:', dialogForm)
              (0, _user.getProjectQuestionInfo)(dialogForm).then(function (res) {
                _this2.$message.warning('反馈成功');
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProjectQuestionInfoData(_x) {
        return _getProjectQuestionInfoData.apply(this, arguments);
      }
      return getProjectQuestionInfoData;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        });
      }
      return isLt2M;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(file) {
        var _this3 = this;
        var tmp;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              tmp = new FormData();
              tmp.append('multipartFile', file);
              _context2.next = 4;
              return (0, _user.postUploadFileByQuestionInfo)(tmp).then(function (res) {
                if (res) {
                  //console.log('uploadImage:', res)
                  _this3.dialogForm.multipartFiles.push(res);
                }
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function uploadImage(_x2) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }()
  }
};